export enum ECouvertureType {
	AMOP = "AMOP",
	AMCP = "AMCP"
}
